import { Route, Routes } from 'react-router-dom'
import { RoutesPath } from './constants/RoutesPath'
import NavbarComponent from './components/navbar/NavbarComponent'
import AboutPage from './pages/AboutPage'
import HomePage from './pages/HomePage'
import ProjectsPage from './pages/ProjectsPage'
import ContactPage from './pages/ContactPage'

export const App = () => (
   <Routes>
      <Route path={RoutesPath.HOME} element={<NavbarComponent />}>
         <Route index element={<HomePage />} />
         <Route path={RoutesPath.ABOUT} element={<AboutPage />} />
         <Route path={RoutesPath.PROJECTS} element={<ProjectsPage />} />
         <Route path={RoutesPath.CONTACT} element={<ContactPage />} />
      </Route>
   </Routes>
)
